import { render } from "./invoiceAddress.vue?vue&type=template&id=242b0e70&scoped=true"
import script from "./invoiceAddress.vue?vue&type=script&lang=js"
export * from "./invoiceAddress.vue?vue&type=script&lang=js"

import "./invoiceAddress.vue?vue&type=style&index=0&id=242b0e70&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242b0e70"]])

export default __exports__